module.exports = __webpack_public_path__ + "static/media/dwt-04.a2da2b7c.jpg";